import React, { Component, Fragment } from 'react';
import {
    MenuItem,
    Select as MaterialSelect,
    TextField,
    Modal,
    CircularProgress
} from "@material-ui/core";
import * as API from "./apiGateway";
import _ from "lodash";

import validator from "validator";
import { getDistanceByKM } from "./calculations";
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';

const INITIAL_FORM_STATE = {
    stationId: LOADING_KEY,
    carNumber: '',
    fullName: '',
    prefix: '',
    phone: '',
    errors: {},
};

const UNKNOWN_ERROR = "קיימת תקלה.\nנסה במועד מאוחר יותר או התקשר למוקד דלקנים 09-8637757";
const FETCH_ERROR = "השרת אינו זמין כעת\nאנא נסו מאוחר יותר";
const LOADING_KEY = "loading";

const ResultModal = ({ text, onClose, isVisible }) => (
    <Modal
        open={isVisible}
        onClose={onClose}>
        <div className="flex flex-col items-center justify-center h-full">
            <div className="flex flex-col form-sent items-center justify-between py-10 text-center">
                <p>
                    {text}
                </p>
                <div className="form-sent-button"
                    onClick={onClose}>
                    <p className="form-sent-text">לסגירה</p>
                </div>
            </div>
        </div>
    </Modal>
);

class DalkanForm extends Component {
    state = {
        ...INITIAL_FORM_STATE,
        allStations: [],
        isUrea: false,
        formSent: false,
        sendingForm: false,
        showError: false,
        fetchError: false,
        errorMessage: ''
    };

    componentDidMount() {
        this._initializePhone();
        this._initializeGasStations();
    }
    filter = createFilterOptions({
        stringify: option => option.name
    })

    render() {
        const { stationId, allStations, carNumber, fullName, prefix, phone, errors, formSent, showError, sendingForm, errorMessage ,value} = this.state;
        console.log('stationId ',stationId)
        return (
            <form className="error-main-form mx-auto text-right">
                <Autocomplete
                    id="combo-box-demo"
                    options={this.state.allStations}
                    getOptionLabel={(option) => option.name}
                    onChange={(e,val)=>{
                        if(val){
                            this.setState({stationId:val.stationId})
                        }
                        else{
                            this.setState({stationId:LOADING_KEY})
                        }
                      }   
                    }
                    style={{ width: '100%'}}
                    filterOptions={this.filter}
                    renderInput={(params) => {
                        return <TextField error = {!_.isEmpty(errors.stationId)} helperText={errors.stationId} {...params}  placeholder="רשימת תחנות" />}}
                />
                {/* <MaterialSelect
                    id="station"
                    label="תחנה"
                    value={stationId || LOADING_KEY}
                    name="station"
                    onChange={this._handleChange('stationId')}
                    fullWidth>
                    {_.isEmpty(allStations) && <MenuItem key={0} value={LOADING_KEY}>מחפש תחנה קרובה..</MenuItem>}

                    {(!_.isEmpty(allStations)) &&
                        allStations.map(station => <MenuItem key={station.stationId}
                            value={station.stationId}>{station.name}</MenuItem>)
                    }
                </MaterialSelect> */}

                <TextField
                    id="carNumber"
                    value={carNumber}
                    inputProps={{ maxLength: 12 }}
                    error={!_.isEmpty(errors.carNumber)}
                    helperText={errors.carNumber}
                    placeholder={"מס' רכב / מס' כרטיס"}
                    onChange={this._handleChange('carNumber')}
                    margin="normal"
                    fullWidth />
                <TextField
                    id="fullName"
                    placeholder="שם הנהג"
                    error={!_.isEmpty(errors.fullName)}
                    helperText={errors.fullName}
                    value={fullName}
                    onChange={this._handleChange('fullName')}
                    margin="normal"
                    fullWidth />
                <div className="flex items-baseline justify-between"><TextField
                    id="phone"
                    placeholder="טלפון"
                    type="tel"
                    value={phone}
                    error={!_.isEmpty(errors.phone)}
                    inputProps={{ maxLength: 7 }}
                    helperText={errors.phone}
                    onChange={this._handleChange('phone')}
                    margin="normal" />
                    <MaterialSelect
                        value={prefix}
                        onChange={this._handleChange('prefix')}
                        name="prefix"
                        error={errors.prefix}>
                        <MenuItem value={'050'}>050</MenuItem>
                        <MenuItem value={'051'}>051</MenuItem>
                        <MenuItem value={'052'}>052</MenuItem>
                        <MenuItem value={'053'}>053</MenuItem>
                        <MenuItem value={'054'}>054</MenuItem>
                        <MenuItem value={'055'}>055</MenuItem>
                        <MenuItem value={'056'}>056</MenuItem>
                        <MenuItem value={'058'}>058</MenuItem>
                        <MenuItem value={'059'}>059</MenuItem>
                    </MaterialSelect>
                </div>
                <div style={{display:'flex',flexDirection:"row", alignItems:'center',justifyContent:'flex-start',marginTop:10}} >
                    <div> לאישור תדלוק אוריאה נא סמן</div>
                    <div onClick={this.onClickCheckbox} style={{width: 20,
        height: 20,
        borderRadius: 4,
        borderWidth: 1,
        borderColor:'#000000',
        
        display:'flex',flexDirection:"row",
        alignItems: 'center',
        justifyContent: 'center',
        marginRight:20
                    }}>{this.state.isUrea && <div style={{backgroundColor:'#B73647',width:5,height:5,padding:5,borderRadius: 3}}></div>}</div>
                    </div>
                <div onClick={this._handleSubmit} className="confirm-error-button text-center mx-auto">
                    {sendingForm ? <CircularProgress className="confirm-text" size={18} color="secondary" /> :
                        <p className="confirm-text">שלח</p>}
                </div>
                <ResultModal isVisible={formSent} onClose={() => this.setState({ formSent: false })}
                    text={<Fragment> בקשתך נקלטה.<br />
                                 אנא המתן לקבלת sms עם מספר אישור.</Fragment>} />
                <ResultModal isVisible={showError} onClose={() => this.setState({ showError: false })}
                    text={errorMessage} />
            </form>
        );
    }

    onClickCheckbox = () => {
        this.setState({isUrea: !this.state.isUrea})
    }

    async _initializeGasStations() {
        try {
            let gasStations = await API.fetchGasStationsList();

            gasStations = await this._trySortStationsByDistance(gasStations);
            console.log('gasStations ', gasStations)
            this.setState({
                allStations: gasStations,
                stationId: LOADING_KEY
            });
        }
        catch (err) {
            this.setState({ showError: true, errorMessage: FETCH_ERROR });
        }
    }

    async _trySortStationsByDistance(gasStations) {
        try {
            const location = await new Promise((resolve, reject) => navigator.geolocation.getCurrentPosition(resolve, reject));
            gasStations = _.sortBy(gasStations, gasStation =>
                getDistanceByKM(gasStation.latitude, gasStation.longitude, location.coords.latitude, location.coords.longitude));
        } catch (error) {
            console.log(error);
            gasStations = _.sortBy(gasStations, station => station.name);
        }
        return gasStations;
    }

    _initializePhone() {
        const params = new URL(document.location).searchParams;
        let prefix = '', phone = '';

        if (params.get("phone")) {
            const userPhone = params.get("phone");
            prefix = userPhone.slice(0, 3);
            phone = userPhone.slice(3, 11);
        }
        this.setState({ prefix, phone });
    }

    _validateForm = () => {
        let errors = {};
        const { fullName, phone, carNumber, prefix, stationId } = this.state;
        if (!/^[\u0590-\u05FF-]{2,15} ([\u0590-\u05FF-]{2,15} ?){1,3}$/.test(fullName)) {
            errors.fullName = "נא להזין שם מלא בעברית"
        }
        if (!validator.isNumeric(prefix) || !validator.isLength(prefix, { min: 3, max: 3 })) {
            errors.prefix = true;
            errors.phone = "נא להזין מספר טלפון תקין"
        }
        if (!validator.isNumeric(phone) || !validator.isLength(phone, { min: 7, max: 7 })) {
            errors.phone = "נא להזין מספר טלפון תקין"
        }
        if (!validator.matches(carNumber, /^מ?\d{1,8}$|^\d{12}$/u)) {
            errors.carNumber = "נא להזין מספר תקין"
        }
        if (!stationId || stationId === LOADING_KEY  ) {
            errors.stationId = "יש לבחור תחנה"
            
        }

        this.setState({ errors });
        return _.isEmpty(errors)
    };

    _handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        })
    };


    _handleSubmit = async () => {
        if (this._validateForm()) {
            this.setState({ sendingForm: true, showError: false, errorMessage: '' });
            const { fullName, phone, prefix, carNumber, stationId,isUrea } = this.state;
           

            const dalkanInfo = {
                "carNumber": carNumber,
                "phoneNumber": prefix + phone,
                "fullName": fullName,
                "stationId": stationId,
                "isUrea" : isUrea,
            };
            try {
                await API.sendErrorForm(dalkanInfo);
                this.setState({ ...INITIAL_FORM_STATE, formSent: true, sendingForm: false })
            } catch (err) {
                const errorString = _.get(err, 'response.data.ReturnString');
                this.setState({ showError: true, sendingForm: false, errorMessage: errorString || UNKNOWN_ERROR })
            }
        }
    };
}

export default DalkanForm;



// WEBPACK FOOTER //
// ./src/DalkanForm.js